<template>
    <dashboard-layout>
        <v-container fluid class="down-top-padding py-0">
            <BaseBreadcrumb
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
            ></BaseBreadcrumb>
            <v-row dense>
                <v-col cols="12">
                    <table-statistics v-if="(this.$page.props.user.usertype === 'sysadmins') || (this.$page.props.user.usertype === 'dataop')"></table-statistics>
                </v-col>
            </v-row>
        </v-container>
    </dashboard-layout>
</template>

<script>
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import TableStatistics from './TableGrids/TableStatistics.vue';

export default {
    name: 'Dashboard',
    props: {
        user: Object,
    },
    components: {
        DashboardLayout,
        BaseBreadcrumb,
        TableStatistics,
    },
    data() {
        return {
            page: {
                title: "Dashboard",
            },
            breadcrumbs: [
                { text: "Dashboard", disabled: true },
            ],
        }
    },
    watch: {},
    computed: {},
    mounted: function () {},
    methods: {

    }
}
</script>
